/** Hints de barcode-lookup / seed viejo. No son ids de catalog_categories. */
const LEGACY_CATEGORY_TO_CANONICAL: Record<string, string> = {
  drinks: 'cat-bebidas-sin-alcohol',
  bebidas: 'cat-bebidas-sin-alcohol',
  'cat-drinks': 'cat-bebidas-sin-alcohol',
  others: 'cat-otros',
  otros: 'cat-otros',
  'cat-others': 'cat-otros',
  snacks: 'cat-snacks',
  cigarettes: 'cat-cigarrillos',
};

export function isLegacyProductCategoryHint(categoryId?: string | null): boolean {
  const key = categoryId?.trim().toLowerCase();
  return Boolean(key && key in LEGACY_CATEGORY_TO_CANONICAL);
}

/** Alias → id canónico. Ids válidos se dejan igual. Vacío → null. */
export function remapLegacyProductCategoryId(categoryId?: string | null): string | null {
  const trimmed = categoryId?.trim() ?? '';
  if (!trimmed) return null;
  return LEGACY_CATEGORY_TO_CANONICAL[trimmed.toLowerCase()] ?? trimmed;
}

/** Payload de cola: apply_product_command lee categoryId, con fallback a category. */
export function remapProductSyncPayload(payload: Record<string, unknown>): Record<string, unknown> {
  const raw = payload.categoryId ?? payload.category;
  const mapped = remapLegacyProductCategoryId(typeof raw === 'string' ? raw : null);
  return { ...payload, categoryId: mapped, category: mapped };
}

export function productQueueErrorLooksStuck(lastError?: string | null): boolean {
  const msg = lastError ?? '';
  return /products_category_id_fkey|products_barcode_key|products_org_barcode_uidx|category_id.*=.*(drinks|others)/i.test(
    msg,
  );
}
